import { ContractReview } from 'approval-workflow/contractReview';
import { NameChangeReview } from 'approval-workflow/name-change-review';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { ProvideContractApprovalWorkflowListState } from 'shared/contexts/contract-approval-workflow-filter-context';
import { ProvideNameChangeApprovalWorkflowListState } from 'shared/contexts/name-change-approval-workflow-filter-context';

export function ApprovalWorkflowRoutes() {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route path={`${path}/contractReview`} exact>
        <ProvideContractApprovalWorkflowListState>
          <ContractReview />
        </ProvideContractApprovalWorkflowListState>
      </Route>
      <Route path={`${path}/Names`} exact>
        <ProvideNameChangeApprovalWorkflowListState>
          <NameChangeReview />
        </ProvideNameChangeApprovalWorkflowListState>
      </Route>
    </Switch>
  );
}
